/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdvancedShippingNotesResponseV3 } from '../models/advanced-shipping-notes-response-v-3';
import { getAdvancedShippingNotesV3 } from '../fn/advanced-shipping-notice/get-advanced-shipping-notes-v-3';
import { GetAdvancedShippingNotesV3$Params } from '../fn/advanced-shipping-notice/get-advanced-shipping-notes-v-3';
import { postAdvancedShippingNotesV3 } from '../fn/advanced-shipping-notice/post-advanced-shipping-notes-v-3';
import { PostAdvancedShippingNotesV3$Params } from '../fn/advanced-shipping-notice/post-advanced-shipping-notes-v-3';


/**
 * Endpoints to manage advanced shipping notices (ASN)
 */
@Injectable({ providedIn: 'root' })
export class AdvancedShippingNoticeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAdvancedShippingNotesV3()` */
  static readonly GetAdvancedShippingNotesV3Path = '/organization-sites/{organizationSiteKey}/consignee/advanced-shipping-notes';

  /**
   * Get advanced shipping notes for an organization site.
   *
   * Returns the stored advanced shipping notes for the given
   * organization site, including the server-computed timestamps
   * (dateCreated, dateUpdated). Returns an empty array when no data
   * has been stored yet.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAdvancedShippingNotesV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdvancedShippingNotesV3$Response(params: GetAdvancedShippingNotesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<AdvancedShippingNotesResponseV3>> {
    const obs = getAdvancedShippingNotesV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get advanced shipping notes for an organization site.
   *
   * Returns the stored advanced shipping notes for the given
   * organization site, including the server-computed timestamps
   * (dateCreated, dateUpdated). Returns an empty array when no data
   * has been stored yet.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAdvancedShippingNotesV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdvancedShippingNotesV3(params: GetAdvancedShippingNotesV3$Params, context?: HttpContext): Observable<AdvancedShippingNotesResponseV3> {
    const resp = this.getAdvancedShippingNotesV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdvancedShippingNotesResponseV3>): AdvancedShippingNotesResponseV3 => r.body)
    );
  }

  /** Path part for operation `postAdvancedShippingNotesV3()` */
  static readonly PostAdvancedShippingNotesV3Path = '/organization-sites/{organizationSiteKey}/consignee/advanced-shipping-notes';

  /**
   * Create or update advanced shipping notes for an organization site.
   *
   * Creates or updates the advanced shipping notes for a specified organization site.
   * Maximum 500 items per request.
   * Duplicate articleOrderNumber + sellableCode pairs are merged:
   * with the same advancedShippingNotice and consigneeOrderNumber the
   * quantities are summed, otherwise the last entry wins.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdvancedShippingNotesV3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAdvancedShippingNotesV3$Response(params: PostAdvancedShippingNotesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = postAdvancedShippingNotesV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create or update advanced shipping notes for an organization site.
   *
   * Creates or updates the advanced shipping notes for a specified organization site.
   * Maximum 500 items per request.
   * Duplicate articleOrderNumber + sellableCode pairs are merged:
   * with the same advancedShippingNotice and consigneeOrderNumber the
   * quantities are summed, otherwise the last entry wins.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdvancedShippingNotesV3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAdvancedShippingNotesV3(params: PostAdvancedShippingNotesV3$Params, context?: HttpContext): Observable<void> {
    const resp = this.postAdvancedShippingNotesV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
